export const DEMO_SYNC_HISTORY = [
  { id: "sh1", started_at: "2026-08-11T06:00:00Z", finished_at: "2026-08-11T06:14:32Z", status: "success" as const, rows: 248_391, duration_sec: 872 },
  { id: "sh2", started_at: "2026-08-10T06:00:00Z", finished_at: "2026-08-10T06:13:58Z", status: "success" as const, rows: 247_882, duration_sec: 838 },
  { id: "sh3", started_at: "2026-08-09T06:00:00Z", finished_at: "2026-08-09T06:01:12Z", status: "partial" as const, rows: 246_104, duration_sec: 72, error: "Rate limit — resumed automatically" },
  { id: "sh4", started_at: "2026-08-08T06:00:00Z", finished_at: "2026-08-08T06:12:44Z", status: "success" as const, rows: 245_901, duration_sec: 764 },
];

export const DEMO_INTEGRATIONS = [
  {
    id: "clevertap",
    name: "CleverTap",
    description: "Subscriber profiles, segments, and campaign delivery hooks",
    status: "connected" as const,
    detail: "Region: eu1 · Profile export API",
    last_checked: "2026-08-11T06:14:32Z",
  },
  {
    id: "supabase",
    name: "Supabase",
    description: "Subscriber warehouse, newsletter issues, segments, audit log",
    status: "pending" as const,
    detail: "Pro approval pending — using demo fixtures locally",
    last_checked: null,
  },
  {
    id: "worker",
    name: "Cloudflare Worker",
    description: "API layer, sync triggers, CleverTap webhooks",
    status: "connected" as const,
    detail: "altibbi-newsletter-api · demo mode",
    last_checked: "2026-08-11T06:15:00Z",
  },
  {
    id: "mysql",
    name: "Altibbi MySQL",
    description: "Newsletter signups from tbi_newsletter + topics from tbi_newsletter_sub_category",
    status: "pending" as const,
    detail: "medical_inno.tbi_newsletter · from 26 Aug 2026",
    last_checked: null,
  },
  {
    id: "ses",
    name: "Email Service",
    description: "Bulk subscriber campaigns — the sending layer behind campaigns",
    status: "planned" as const,
    detail: "Campaigns own the send. The provider is an implementation detail.",
    last_checked: null,
  },
  {
    id: "cf-email",
    name: "Cloudflare Email Sending",
    description: "Transactional previews from newsletter@altibbi.me",
    status: "connected" as const,
    detail: "Domain altibbi.me onboarded · preview sends only",
    last_checked: null,
  },
  {
    id: "r2",
    name: "Cloudflare R2",
    description: "HTML previews and exported campaign assets",
    status: "planned" as const,
    detail: "Phase 2 — newsletter preview storage",
    last_checked: null,
  },
];

export const DEMO_SETTINGS = {
  sync_schedule: "Every 10 minutes · member ingest",
  sync_cron: "*/10 * * * *",
  notify_on_sync_fail: true,
  notify_on_campaign_sent: true,
  default_sender_name: "Altibbi",
  default_reply_to: "newsletter@altibbi.me",
  timezone: "Asia/Amman",
};
